import Vue from 'vue';

import BaseAlert from '@/components/base-components/components/base-alert.vue';
import BaseBadge from '@/components/base-components/components/badge/base-badge.vue';
import BaseBanner from '@/components/base-components/components/base-banner.vue';
import BaseBreadcrumbs from '@/components/base-components/components/breadcrumbs/base-breadcrumbs.vue';
import BaseBreadcrumbsItem from '@/components/base-components/components/breadcrumbs/base-breadcrumbs-item.vue';
import BaseBreadcrumbsDivider from '@/components/base-components/components/breadcrumbs/base-breadcrumbs-divider.vue';
import BaseButton from '@/components/base-components/components/button/base-button.vue';
import BaseButtonGroup from '@/components/base-components/components/button/base-button-group.vue';
import BaseCalendar from '@/components/base-components/components/calendar/base-calendar.vue';
import BaseChart from '@/components/base-components/components/base-chart.vue';
import BaseCheckbox from '@/components/base-components/components/checkbox/base-checkbox.vue';
import BaseColorPalette from '@/components/base-components/components/color/base-color-palette.vue';
import BaseColorPaletteItem from '@/components/base-components/components/color/base-color-palette-item.vue';
import BaseCodeEditor from '@/components/base-components/components/code-editor/base-code-editor.vue';
import BaseCollapse from '@/components/base-components/components/collapse/base-collapse.vue';
import BaseCollapseItem from '@/components/base-components/components/collapse/base-collapse-item.vue';
import BaseDivider from '@/components/base-components/components/base-divider.vue';
import BaseDraggable from '@/components/base-components/components/base-draggable.vue';
import BaseDrawer from '@/components/base-components/components/drawer/base-drawer.vue';
import BaseDropdown from '@/components/base-components/components/dropdown/base-dropdown.vue';
import BaseDropdownItem from '@/components/base-components/components/dropdown/base-dropdown-item.vue';
import BaseDatePicker from '@/components/base-components/components/date-picker/base-date-picker.vue';
import BaseDatePickerContent from '@/components/base-components/components/date-picker/base-date-picker-content.vue';
import BaseIcon from '@/components/base-components/components/base-icon.vue';
import BaseInfo from '@/components/base-components/components/base-info.vue';
import BaseInput from '@/components/base-components/components/input/base-input.vue';
import BaseInputArrayAsString from '@/components/base-components/components/input/base-input-array-as-string.vue';
import BaseInputNumber from '@/components/base-components/components/input/base-input-number.vue';
import BaseJsonEditor from '@/components/base-components/components/code-editor/json/base-json-editor.vue';
import BaseJsonForm from '@/components/base-components/components/json-form/base-json-form.vue';
import BasePinCode from '@/components/base-components/components/pin-code/base-pin-code.vue';
import BaseMessage from '@/components/base-components/components/message/base-message.vue';
import BaseModal from '@/components/base-components/components/base-modal.vue';
import BaseNotification from '@/components/base-components/components/notification/base-notification.vue';
import BaseNumberAnimate from '@/components/base-components/components/base-number-animate.vue';
import BaseOverlay from '@/components/base-components/components/base-overlay.vue';
import BasePagination from '@/components/base-components/components/pagination/base-pagination.vue';
import BasePopover from '@/components/base-components/components/base-popover.vue';
import BasePopConfirm from '@/components/base-components/components/base-pop-confirm.vue';
import BaseProgress from '@/components/base-components/components/base-progress.vue';
import BaseRadio from '@/components/base-components/components/radio/base-radio.vue';
import BaseRadioGroup from '@/components/base-components/components/radio/base-radio-group.vue';
import BaseRate from '@/components/base-components/components/base-rate.vue';
import BaseScroll from '@/components/base-components/components/scroll/base-scroll.vue';
import BaseSnapScroll from '@/components/base-components/components/snap-scroll/base-snap-scroll.vue';
import BaseSelect from '@/components/base-components/components/select/base-select.vue';
import BaseSelectOption from '@/components/base-components/components/select/base-select-option.vue';
import BaseSpinner from '@/components/base-components/components/base-spinner.vue';
import BaseSteps from '@/components/base-components/components/steps/base-steps.vue';
import BaseStep from '@/components/base-components/components/steps/base-step.vue';
import BaseSwitcher from '@/components/base-components/components/switcher/base-switcher.vue';
import BaseTab from '@/components/base-components/components/tabs/base-tab.vue';
import BaseTabs from '@/components/base-components/components/tabs/base-tabs.vue';
import BaseTag from '@/components/base-components/components/tag/base-tag.vue';
import BaseTimePicker from '@/components/base-components/components/time-picker/base-time-picker.vue';
import BaseToggle from '@/components/base-components/components/toggle/base-toggle.vue';
import BaseTooltip from '@/components/base-components/components/tooltip/base-tooltip.vue';
import BaseUpload from '@/components/base-components/components/upload/components/base-upload.vue';
import BaseVideo from '@/components/base-components/components/base-video.vue';
import BaseVirtualList from '@/components/base-components/components/virtual-list/base-virtual-list.vue';

// @ts-expect-error not typed yet
import copy from '@/components/base-components/directives/copy';
// @ts-expect-error not typed yet
import dropArea from '@/components/base-components/directives/drop-area';
// @ts-expect-error not typed yet
import loader from '@/components/base-components/directives/loader';

Vue.component('BaseAlert', BaseAlert);
Vue.component('BaseBadge', BaseBadge);
Vue.component('BaseBanner', BaseBanner);
Vue.component('BaseBreadcrumbs', BaseBreadcrumbs);
Vue.component('BaseBreadcrumbsItem', BaseBreadcrumbsItem);
Vue.component('BaseBreadcrumbsDivider', BaseBreadcrumbsDivider);
Vue.component('BaseButton', BaseButton);
Vue.component('BaseButtonGroup', BaseButtonGroup);
Vue.component('BaseCalendar', BaseCalendar);
Vue.component('BaseChart', BaseChart);
Vue.component('BaseCheckbox', BaseCheckbox);
Vue.component('BaseColorPalette', BaseColorPalette);
Vue.component('BaseColorPaletteItem', BaseColorPaletteItem);
Vue.component('BaseCodeEditor', BaseCodeEditor);
Vue.component('BaseCollapse', BaseCollapse);
Vue.component('BaseCollapseItem', BaseCollapseItem);
Vue.component('BaseDivider', BaseDivider);
Vue.component('BaseDraggable', BaseDraggable);
Vue.component('BaseDrawer', BaseDrawer);
Vue.component('BaseDropdown', BaseDropdown);
Vue.component('BaseDropdownItem', BaseDropdownItem);
Vue.component('BaseDatePicker', BaseDatePicker);
Vue.component('BaseDatePickerContent', BaseDatePickerContent);
Vue.component('BaseIcon', BaseIcon);
Vue.component('BaseInfo', BaseInfo);
Vue.component('BaseInput', BaseInput);
Vue.component('BaseInputArrayAsString', BaseInputArrayAsString);
Vue.component('BaseInputNumber', BaseInputNumber);
Vue.component('BaseJsonEditor', BaseJsonEditor);
Vue.component('BaseJsonForm', BaseJsonForm);
Vue.component('BasePinCode', BasePinCode);
Vue.component('BaseMessage', BaseMessage);
Vue.component('BaseModal', BaseModal);
Vue.component('BaseNotification', BaseNotification);
Vue.component('BaseNumberAnimate', BaseNumberAnimate);
Vue.component('BaseOverlay', BaseOverlay);
Vue.component('BasePagination', BasePagination);
Vue.component('BasePopover', BasePopover);
Vue.component('BasePopConfirm', BasePopConfirm);
Vue.component('BaseProgress', BaseProgress);
Vue.component('BaseRadio', BaseRadio);
Vue.component('BaseRadioGroup', BaseRadioGroup);
Vue.component('BaseRate', BaseRate);
Vue.component('BaseSelect', BaseSelect);
Vue.component('BaseSelectOption', BaseSelectOption);
Vue.component('BaseScroll', BaseScroll);
Vue.component('BaseSnapScroll', BaseSnapScroll);
Vue.component('BaseSpinner', BaseSpinner);
Vue.component('BaseSteps', BaseSteps);
Vue.component('BaseStep', BaseStep);
Vue.component('BaseSwitcher', BaseSwitcher);
Vue.component('BaseTab', BaseTab);
Vue.component('BaseTabs', BaseTabs);
Vue.component('BaseTag', BaseTag);
Vue.component('BaseTimePicker', BaseTimePicker);
Vue.component('BaseToggle', BaseToggle);
Vue.component('BaseTooltip', BaseTooltip);
Vue.component('BaseUpload', BaseUpload);
Vue.component('BaseVideo', BaseVideo);
Vue.component('BaseVirtualList', BaseVirtualList);

Vue.directive('copy', copy);
Vue.directive('drop-area', dropArea);
Vue.directive('loader', loader);
